module.exports = __webpack_public_path__ + "img/kn.f8310b40.svg";